// Mock data for Brookline JP Patriots

export const teamName = '"ICE" BROOKLINE JP PATRIOTS';
export const teamSubtitle = 'BROOKLINE JAMAICA PLAIN POP WARNER FOOTBALL & CHEERLEADING';

// ICE official logo
export const iceLogo = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/kre3rccy_blob-73ff62c.png';

// ICE Program patch (embroidered — for coach card badges)
export const icePatch = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/3kq07klr_IMG_5389.webp';

// Apparel Store — payment link + product catalog
export const autobookPayUrl = 'https://app.autobooks.co/pay/brookline-jamaica-plain';
export const invoiceEmail = 'jmadstorm@gmail.com';
export const contactEmails = ['sydney.fuller-jones@mass.gov', 'cooljeff12@gmail.com'];
export const contactMailto = `mailto:${contactEmails.join(',')}`;

export const apparelProducts = [
  {
    id: 'tshirt-classic',
    name: 'Patriots Hoodie',
    tagline: 'Heavyweight Fleece · Navy & Red',
    price: 45,
    variants: ['Navy', 'Red'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/qhkqua8u_IMG_7784.webp',
    category: 'Apparel'
  },
  {
    id: 'hoodie-ice',
    name: 'Patriots T-Shirt',
    tagline: 'Brookline-JP · Classic Team Tee',
    price: 10,
    variants: ['Navy', 'Red'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/1byb9fih_IMG_7780.webp',
    category: 'Apparel'
  },
  {
    id: 'tshirt-long-sleeve',
    name: 'Patriots Long Sleeve T-Shirt',
    tagline: 'Long Sleeve · Brookline-JP Patriots',
    price: 20,
    variants: ['Navy', 'Red'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/1xnnldm4_IMG_7693.webp',
    category: 'Apparel'
  },
  {
    id: 'hoodie-red',
    name: 'ICE Special Edition Hoodie',
    tagline: 'Limited Edition · ICE Logo · Only 20 Made',
    price: 50,
    variants: ['Red', 'Navy'],
    sizes: ['S', 'M', 'L', 'XL', 'XXL', 'YS', 'YM', 'YL'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/3w01888f_IMG_7691.webp',
    category: 'Apparel'
  },
  {
    id: 'beanie-stars',
    name: 'Stars & Stripes Beanie',
    tagline: 'Knit · Tassel & Pom Detail',
    price: null,
    variants: [],
    sizes: ['One Size'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/sn0t53et_IMG_7688.webp',
    category: 'Headwear'
  },
  {
    id: 'bucket-hat-gray',
    name: 'Patriots Bucket Hat',
    tagline: 'Embroidered · Heather Gray',
    price: null,
    variants: [],
    sizes: ['S/M', 'L/XL'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/pxb0biat_IMG_7687.webp',
    category: 'Headwear'
  },
  {
    id: 'cap-flexfit-navy',
    name: 'Flexfit Cap (Navy)',
    tagline: 'Brookline-JP Patriots Football · Flexfit',
    price: null,
    variants: [],
    sizes: ['S/M', 'L/XL'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/c41791lg_IMG_7682.webp',
    category: 'Headwear'
  },
  {
    id: 'cap-plaid',
    name: 'Patriots Plaid Cap',
    tagline: 'Genuine Dickies · Classic Plaid',
    price: null,
    variants: [],
    sizes: ['One Size'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/xaruudf1_IMG_7683.webp',
    category: 'Headwear'
  },
  {
    id: 'cap-red',
    name: 'Patriots Cap (Red)',
    tagline: 'Brookline J.P. · Structured Red',
    price: null,
    variants: [],
    sizes: ['One Size'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/4gujepeh_IMG_7684.webp',
    category: 'Headwear'
  },
  {
    id: 'cap-black',
    name: 'Patriots Cap (Black)',
    tagline: 'Brookline J.P. · Classic Adjustable',
    price: null,
    variants: [],
    sizes: ['One Size'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/dkdz9p8e_IMG_7685.webp',
    category: 'Headwear'
  },
  {
    id: 'cap-twotone',
    name: 'Patriots Two-Tone Cap',
    tagline: 'Black & Gray · Team Issued',
    price: null,
    variants: [],
    sizes: ['One Size'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/jka9crv5_IMG_7686.webp',
    category: 'Headwear'
  },
  {
    id: 'cap-camo-fitted',
    name: 'Camo Fitted Cap',
    tagline: 'New Era 59Fifty · Brookline J.P. Urban Camo',
    price: null,
    variants: [],
    sizes: ['7 1/4', '7 3/8', '7 1/2', '7 5/8'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/9rublj7t_IMG_7678.webp',
    category: 'Headwear'
  },
  {
    id: 'visor-red-hair',
    name: 'Patriots Novelty Hair Visor',
    tagline: 'Red Wig Visor · Ultimate Sideline Spirit',
    price: 15,
    variants: [],
    sizes: ['One Size'],
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/9hwkydbz_IMG_7676.webp',
    category: 'Fan Gear'
  }
];


// Hero fans photo
export const heroFans = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/0nly66st_IMG_2452.jpeg';

// Experience the Thrill of Victory — Original coaches photo (foundational shot)
export const heroVictory = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/za3hao7l_IMG_9533.JPG';

// 2021 National League U8 Division 2 Champions — coach + plaque (hero overlay)
export const heroChampion = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/c4vgxngi_65048D27-C12B-4D80-9A30-20FB3CAE9D46.jpeg';

// Executive Board — Program leadership
export const executiveBoard = [
  {
    role: 'President',
    name: 'Jeff Hammond',
    phone: '617-818-8296',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/tbp8txtu_Excecutive%20board%20President%20Jeff%20HAMMOND.webp'
  },
  {
    role: 'Vice-President',
    name: 'Edgiton Farquharson',
    phone: '617-595-5404',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/j1o12nik_Executive%20Board%20Vice%20-%20President%20Edgiton%20FARQUHARSON.jpeg'
  },
  {
    role: 'Treasurer',
    name: 'Position Open',
    phone: '',
    img: ''
  },
  {
    role: 'Secretary',
    name: 'Ms. Sydney Fuller-Jones',
    titles: ['Director of Operations', 'Scholastic Coordinator', 'Secretary'],
    phone: '617-680-4588',
    img: '/images/board/sydney-fuller-jones.jpg'
  }
];

// Program Directors — separate row below Executive Board (football + cheer)
export const programDirectors = [
  {
    role: 'Director of Football Operations',
    name: 'Mr. Michael Garvin',
    phone: '857-312-4728',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/4qs6bgl0_IMG_7601.webp'
  },
  {
    role: 'Cheerleading Coordinator',
    name: 'Ms. Yamiley Miller',
    phone: '857-919-2500',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/9j5reboq_yamiley%20millor.webp'
  }
];

// Cheerleading Coordinator — separate row below Executive Board
export const cheerCoordinator = {
  role: 'Cheerleading Coordinator',
  name: 'Ms. Yamiley Miller',
  phone: '857-919-2500',
  img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/9j5reboq_yamiley%20millor.webp'
};

// Kejuan Farquharson alumni photo
export const kejuanPhoto = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/vzn2tmds_IMG_2452.jpeg';

// Join the Winning Team — 2025 NMPW 7U Division Champions
export const joinTeamImage = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/vm6h4zn2_IMG_3531%203.webp';

export const heroImages = [
  heroFans,
  'https://images.unsplash.com/photo-1706675780107-7c43cc487928?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxzdGFkaXVtJTIwbGlnaHRzfGVufDB8fHx8MTc4NDM0MTA2MHww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1663563624389-95349417e247?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHx5b3V0aCUyMGZvb3RiYWxsfGVufDB8fHxibHVlfDE3ODQzNDEwNTN8MA&ixlib=rb-4.1.0&q=85'
];

export const galleryImages = [
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/a1ewkw8j_blob-0003.png',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/bo5npeqp_1378812523528494761.jpg',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/c4vgxngi_65048D27-C12B-4D80-9A30-20FB3CAE9D46.jpeg',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/v3f2kszl_f7dccb0e-5c1c-4193-9ad6-71f7d70a5432.jpeg',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/fuu98uyr_fb_395090139451930_1600x900.jpg',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/yyoljhgv_ed9addf9-8470-44d5-9e7e-aca224fb1a62.jpeg',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/jmh8orjf_470238679_1249160119472738_103394912446763162_n.jpg',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/ot86da0x_83732389_1730044962932404_r.jpeg-e67db8e.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/qlsao11p_1c7k2dlph_520810.webp',
  // Recent additions — Pictorial Journey of Our Love for the Sport
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/5bci4ju3_IMG_7847.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/uu7rwhea_IMG_7845.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/7m57xhft_IMG_7846.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/13c1ca8k_IMG_7844.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/ogye4tdc_IMG_7843.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/2n98ar25_IMG_7848.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/hd697un4_IMG_7849.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/ypfyt60t_IMG_7852.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/o9r4omq6_IMG_7854.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/gubokjun_IMG_7842.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/woxci5gk_IMG_7838.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/yo7y3xxp_IMG_7841.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/isd7u6rj_IMG_7853.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/uek626n6_IMG_7850.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/7r2s9r3g_IMG_7851.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/ap8g7rda_IMG_1095%203.JPG',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/114vrr6o_IMG_7839.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/i5yywq5b_IMG_7840.webp',
];

export const coachImages = [
  'https://images.unsplash.com/photo-1585757318177-0570a997dc3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxmb290YmFsbCUyMGNvYWNofGVufDB8fHx8MTc4NDM0MTA1M3ww&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/32205613/pexels-photo-32205613.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.pexels.com/photos/32101180/pexels-photo-32101180.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
];

export const testimonials = [
  { name: 'Marcus J.', role: 'Parent', quote: 'Let\u2019s Go Patriots!!!!! This program has given my son confidence, discipline, and a family for life.' },
  { name: 'Danielle W.', role: 'Cheer Mom', quote: 'The coaches truly care. My daughter came home smiling every practice \u2013 championship season was unforgettable.' },
  { name: 'Coach Rob', role: 'Alumni', quote: '20 years strong. This program built me into the man I am today. Once a Patriot, always a Patriot.' }
];

export const coaches = [
  // U7
  { name: 'Coach Pablo Flores', division: 'U7', role: 'Head Coach — U7', bio: 'Head Coach of the U7 squad. Leading our youngest football scholars into the game with heart, patience, and championship spirit.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/vtinvx3o_IMG_7619.webp' },
  { name: 'Coach Michael Garvin', division: 'U7', role: 'Assistant Coach — U7', bio: 'Assistant Coach for the U7 squad. "Coach Mike" — mentor, motivator, and Patriots family through and through.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/5ahxunfr_IMG_7601%203.webp' },
  { name: 'Ms. Snanice Locus-Whitley', division: 'U7', role: 'Team Mom — U7', bio: 'Team Mom for the U7 squad. Snacks, spirit, and support for our youngest Patriots and their families.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/a8s2zkr6_IMG_7630.webp' },
  // U9
  { name: 'Coach Phillip Smith', division: 'U9', role: 'Head Coach — U9', bio: 'Head Coach of the U9 squad. Building the foundation — fundamentals, fun, and a love of the game for our youngest Patriots.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/vc6tsc6h_IMG_7532.webp' },
  { name: 'Coach Terick Cotterell', division: 'U9', role: 'Assistant Coach — U9', bio: 'Assistant Coach of the U9 squad. Bringing energy, mentorship, and hands-on player development to our youngest Patriots.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/v7nm5y45_IMG_7534.webp' },
  { name: 'Coach Giovanny Cruz', division: 'U9', role: 'Assistant Coach — U9', bio: 'Assistant Coach for the U9 squad. Teaching the fundamentals with patience and energy so every young Patriot plays fast, safe, and confident.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/to0s6g33_IMG_7956.webp' },
  { name: 'Ms. Sadida Fonseca', division: 'U9', role: 'Equipment Manager — U9', bio: 'Equipment Manager for the U9 squad. Helmets fitted, pads checked, and every Patriot geared up right before they step on the field.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/l6natyt5_IMG_7952.webp' },
  { name: 'Ms. Angel Thomas', division: 'U9', role: 'Trainer — U9', bio: 'Trainer for the U9 squad. Keeping our youngest scholar-athletes hydrated, healthy, and ready to compete every practice and game day.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/xuvfzcos_IMG_7955.webp' },
  // U11
  { name: 'Coach Jeff Hammond', division: 'U11', role: 'Head Coach — U11', bio: 'Head Coach of the U11 squad. Nicknamed "Cool Jeff" — a Patriots lifer who leads with heart, discipline, and a championship pedigree.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/xu5r26cz_IMG_7533.webp' },
  { name: 'Coach Adam Martin', division: 'U11', role: 'Assistant Coach — U11', bio: 'Assistant Coach of the U11 squad. Focused on player development, fundamentals, and pushing our scholars to be their best.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/4pp5w3j9_IMG_7600.webp' },
  { name: 'Ms. Camille Muhammad', division: 'U11', role: 'Team Mom — U11', bio: 'Team Mom for the U11 squad. Snacks, schedules, sideline support, and heart for our Patriots family.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/pegwzye7_IMG_7668.webp' },
  { name: 'Ms. Rachel Yee', division: 'U9', role: 'Team Mom — U9', bio: 'Team Mom for the U9 squad. Keeps the team hydrated, on-schedule, and cheered on at every game.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/rpqsuunq_IMG_7631.webp' },
  // U13
  { name: 'Coach Edgiton Farquharson', division: 'U13', role: 'Head Coach — U13', bio: 'Head Coach of the U13 squad. Bringing structure, energy, and championship mindset to every practice and every game.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/55h2kno6_IMG_7537.webp' },
  { name: 'Coach Lafayette Benson', division: 'U13', role: 'Assistant Coach — U13', bio: 'Assistant Coach for the U13 squad. Player development, film breakdown, and next-level linebacker coaching.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/olv9nemg_IMG_7535.webp' },
  { name: 'Coach Kris Tyler', division: 'U13', role: 'Assistant Coach — U13', bio: 'Assistant Coach for the U13 squad. Football team parent and dedicated mentor for our student-athletes.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/n30qodqa_coach%20kris%20tyler.jpeg' },
  { name: 'Ms. Rebecca Rainey', division: 'U13', role: 'Team Mom — U13', bio: 'Team Mom for the U13 squad. Snacks, spirit, and the glue that keeps our Patriots family running.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/5ilrnxai_Rebecca%20Rainey.webp' },
  { name: 'Coach Eric Rainey', division: 'U13', role: 'Team Trainer — U13', bio: 'Team Trainer for the U13 squad. Supporting player readiness, safe preparation, and the health of every scholar-athlete.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/8dgzveij_IMG_7863.webp' },
  { name: 'Coach Michael Garrity', division: 'U13', role: 'Offensive Coach — U13', bio: 'Offensive Coach for the U13 squad. Developing strong fundamentals, confident playmakers, and a disciplined Patriots offense.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/30iu2zq6_IMG_7864.webp' },
  { name: 'Coach Trent', division: 'U13', role: 'Defensive Coach — U13', bio: 'Defensive Coach for the U13 squad. Building disciplined fundamentals, strong communication, and a confident Patriots defense.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/44sysl24_trent%20.JPWhitley.G.JPG' },
  // Cheerleading Coaches
  { name: 'Ms. Yamiley Miller', division: 'Cheerleading Coaches', role: 'Cheer Coordinator', bio: 'The brains behind the cheers. Yamiley and her dedicated cheer staff have brought regional, state, and national championships to the ICE Brookline Jamaica Plain Patriots. Her passion, leadership, and commitment to excellence have elevated the cheerleading program to the highest levels of competition, making her an integral part of the ICE Patriots family.', phone: '857-919-2500', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/eytjdb5v_Screenshot_20260331_131922_Messages.webp' },
  { name: 'Coach Erica', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Bringing energy, precision, and spirit to every practice and every sideline.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/c173wr5t_IMG_4449.JPEG' },
  { name: 'Coach Natacha', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Choreography, tumbling, and building confident young performers.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/i6ph8rkk_IMG_20260208_192303250_BURST000_COVER.webp' },
  { name: 'Coach Vena', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Stunts, spirit, and championship-level mentorship for our squad.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/tddh7akz_IMG_1010.JPEG' },
  { name: 'Coach Skye', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Focused on technique, teamwork, and bringing out the best in every athlete.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/ongbxlou_IMG_4642%202.webp' },
  { name: 'Coach Sienna', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Sideline energy, sharp choreography, and a heart for every athlete.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/6rtp4i28_IMG_7639.webp' },
  { name: 'Coach Tarese', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Building confidence, spirit, and championship habits in every practice.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/5784xemw_20260809_180800.webp' },
  { name: 'Coach Martine', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Fundamentals-first mentor helping our squad shine on and off the field.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/gmietprr_4094875731561899623.JPG' },
  { name: 'Coach Tiffany', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Precision routines, positive coaching, and a family-first approach.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/jtrv1nql_4876957708658903882.webp' },
  { name: 'Coach Deshawna', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Bringing high-energy stunts, spirit, and mentorship to our squad.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/bm1y9fl9_IMG_5092.webp' },
  { name: 'Coach Jasmine', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Energy, encouragement, and championship coaching for every athlete.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/vuzrj3kj_2847546533269123420.webp' },
  { name: 'Coach Brittney', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Sharp technique, strong sisterhood, and sideline spirit every game.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/7o0gatie_IMG_0141.JPEG' },
  { name: 'Coach Kat', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Big smiles, fierce routines, and a mentor our squad can count on.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/zwiq4pjg_IMG_4847.JPG' },
  { name: 'Coach Robyn', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Focused on confidence, choreography, and lifting the whole team up.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/5d7u5t7t_IMG_4846.JPG' },
  { name: 'Coach Monica', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Determined, dedicated, and building strong young performers.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/xyt3votu_2940430793473939662.JPG' },
  { name: 'Coach Denecia', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Poise, precision, and a mentor helping every athlete grow.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/mam8nb79_RenderedImage_ff0a99bb-33eb-4916-8ad2-22fe12e1ae49.JPEG' },
  { name: 'Coach Amefika', division: 'Cheerleading Coaches', role: 'Cheer Coach', bio: 'Cheer coach for the Patriots. Warmth, wisdom, and a love for building confident young cheerleaders.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/9dkwh6gt_1643548618308568397.JPG' }
];

export const coachingGroupsOrder = ['U7', 'U9', 'U11', 'U13', 'Cheerleading Coaches'];

export const teams = [
  { name: 'U7 Football', age: 'Ages 5-7', division: 'Football', desc: 'Introduction to Pop Warner football fundamentals in a safe, fun environment. 2025 NMPW Northeastern MA 7U Division 2 CHAMPIONS.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/j7qj12dw_IMG_3520.jpeg' },
  { name: 'U9 Football', age: 'Ages 7-9', division: 'Football', desc: 'U9 Division CHAMPIONS. Building fundamentals with more advanced schemes and positions on the way to a championship season.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/fwiustra_fb_395090139451930_1600x900.jpg' },
  { name: 'U11 Football', age: 'Ages 9-11', division: 'Football', desc: 'Competitive league play with regional tournament opportunities. 11U team representing Brookline Jamaica Plain Patriots.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/nugofnq2_IMG_7912.webp' },
  { name: 'U13 Football', age: 'Ages 11-13', division: 'Football', desc: 'High-level competition preparing scholars for high school football.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/axcwutjs_IMG_7785.webp' },
  { name: 'U5 Football', age: 'Ages 5', division: 'Football', desc: 'Youngest Patriots football division — introducing our tiniest athletes to the fundamentals of the game, teamwork, and the Patriots family.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/tpgqjok7_IMG_8781.webp' },
  { name: 'Varsity Cheer', age: 'Ages 11-14', division: 'Cheer', desc: 'YCADA Globals NATIONAL CHAMPIONS. Nationally competitive squad. Stunts, tumbling, and championship choreography.', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/v5jf50bn_470238679_1249160119472738_103394912446763162_n.jpg' }
];

export const events = [
  {
    day: 'SAT',
    month: 'AUG',
    date: '15',
    year: '2026',
    title: 'Patriots Family Barbecue',
    time: '2:00 PM \u2013 6:00 PM',
    location: '239 Parker Hill Ave, Boston, MA',
    desc: 'Food. Fun. Family. Community. Kick off the 2026 season with the whole Patriots family — burgers, dogs, sides, and a whole lot of Patriots pride.',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/n4vxlzcl_2026-07-13.png',
    featured: true
  },
  {
    day: 'THU',
    month: 'AUG',
    date: '13',
    year: '2026',
    title: 'NFL Preseason Game 1 — Colts at Patriots',
    time: '7:30 PM',
    location: 'Gillette Stadium, Foxborough, MA',
    desc: '"ICE" Brookline Jamaica Plain Pop Warner Football & Cheerleading will have tickets for this game. Players, coaches, and parents who are interested — reach out to the program. GO PATRIOTS!'
  },
  { day: 'SAT', month: 'AUG', date: '23', title: 'Preseason Scrimmage', time: '10:00 AM \u2013 2:00 PM', location: 'Downes Field, Brookline, MA', desc: 'Open scrimmage vs. neighboring Pop Warner programs. Free admission.' },
  { day: 'SUN', month: 'SEP', date: '07', title: 'Opening Day Home Game', time: '12:00 PM \u2013 4:00 PM', location: 'Skyline Park, JP', desc: 'First official game of the season. Wear your Navy and Red!' },
  { day: 'SAT', month: 'SEP', date: '20', title: 'Cheer Showcase Night', time: '6:00 PM \u2013 8:30 PM', location: 'Brookline High School Gym', desc: 'All cheer divisions perform their new routines. Family & friends welcome.' },
  { day: 'SAT', month: 'OCT', date: '04', title: 'Homecoming & Alumni Day', time: '11:00 AM \u2013 5:00 PM', location: 'Skyline Park, JP', desc: '20 years strong! Alumni return to celebrate two decades of Patriots pride.' },
  { day: 'SAT', month: 'NOV', date: '15', title: 'Regional Playoff Tournament', time: 'All Day', location: 'TBD', desc: 'Postseason begins. Bring your loudest cheers.' }
];

// Young Scholars — 2x2 spotlight (photo + name + year)
export const youngScholars = [
  {
    name: 'Ryan Benson',
    year: '2025 · New England Pop Warner All-American Scholar',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/3aalodb4_Resized_Resized_20240224_132616_1708800021583.JPEG',
    focus: '78% 20%',
    featured: true
  },
  {
    name: 'Ramel Rainey',
    year: '2025 · New England Pop Warner All-American Scholar',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/j39c4k23_Resized_Resized_20240224_132948_1708800019830.JPEG',
    focus: 'center 15%',
    featured: true
  },
  { name: 'Kyan-King Tyler',
    year: '2025 · New England Pop Warner All-American Scholar',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/mqiynukf_Resized_Resized_20240224_184717_1708818548953.jpeg',
    focus: 'center 25%',
    featured: true
  }
];

// Award scans slideshow — used in Scholars slot #4 (rotating slideshow of all award certificates)
export const awardScans = [
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/3vtc2fum_SCAN0546.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/5ht4c5ay_SCAN0547.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/lf3litrt_SCAN0548.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/ge03jcrn_SCAN0550.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/xssefp0i_SCAN0551.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/tg71td7g_SCAN0552.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/lx7ngxpl_SCAN0553.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/pj4evstj_SCAN0554.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/znjmuy0s_SCAN0556.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/fw8zkjqo_SCAN0557.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/jxqc79yz_SCAN0558.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/fx2ro8lw_SCAN0559.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/nn480ztp_SCAN0549.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/57nd1405_SCAN0555.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/09lprsrt_SCAN0561.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/t3z2ua3y_SCAN0562.webp',
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/mlkm1xhl_SCAN0563.webp'
];

// Weekly Practice Schedule
export const practiceSchedule = {
  switchDate: '2026-09-01', // date when preseason ends and regular season begins
  preseason: {
    label: 'Preseason',
    days: [1, 2, 3, 4], // Mon, Tue, Wed, Thu
    time24: '17:30',
    endTime24: '19:30',
    location: 'McLaughlin Playground (across from 239 Parker Hill Ave, Roxbury, MA)'
  },
  regularSeason: {
    label: 'Regular Season',
    days: [2, 3, 4], // Tue, Wed, Thu
    time24: '17:30',
    endTime24: '19:30',
    location: 'McLaughlin Playground (across from 239 Parker Hill Ave, Roxbury, MA)'
  }
};


export const alumni = [
  {
    name: 'Kejuan Farquharson',
    year: 'Class of 2020',
    position: 'Running Back / Cornerback · #25',
    school: 'Concord-Carlisle High School',
    college: 'Springfield College — RB / CB',
    img: kejuanPhoto,
    featured: true,
    quote: 'The Patriots taught me discipline, brotherhood, and how to compete. Everything I am on the field started at BJP.',
    bio: 'A standout alumnus of the "ICE" Brookline JP Patriots program, Kejuan — known to teammates as “Key” — starred at Concord-Carlisle High School before continuing his football career at Springfield College as a Running Back and Cornerback. An impact player from his freshman year, he battled through adversity, learned from every experience, and continued to make a difference day in and day out. Kejuan became a dynamic kick returner, returning two kickoffs for touchdowns in his final season, while his willingness to embrace his role and help build the Brotherhood earned the highest praise from his coaches. He pursued a degree in Criminal Justice and carried forward the same ability to adapt, attack, and overcome that defined his time on Alden Street — embodying the Patriot values of hard work, discipline, resilience, and heart.',
    showcaseImg: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/hvjuziz5_IMG_2234.webp',
    showcaseAlt: 'Springfield College Senior Showcase honoring Kejuan Farquharson and sharing a message from his coaches',
    highlight: {
      img: '/alumni/kejuan-100-yard-return.jpg',
      alt: 'Kejuan Farquharson diving across the goal line to finish a 100-yard kickoff return touchdown for Springfield College',
      date: 'October 12, 2019',
      label: '100-Yard Kickoff Return · Springfield College Record',
      text: '7:38 to play. The fans in attendance would then witness history as Kejuan Farquharson (Hyde Park, Mass.) took the next kickoff 100 yards for the score, setting a new Springfield College record and marking just the 93rd time in NCAA Division III history that a kickoff has been returned for a touchdown from 100 yards out.',
      source: 'Brookline JP Patriots · Oct 12, 2019'
    }
  },
  {
    name: 'Keyón Lungelow',
    slug: 'keyon-lungelow',
    year: 'Cathedral HS · Varsity QB1',
    position: 'Quarterback · Patriots #7 / #11 → Cathedral #14 / #3',
    school: 'BJP Patriots → Cathedral High School',
    college: 'Cathedral High School — Varsity QB1 (junior year); JV QB1 as a freshman and sophomore',
    img: 'https://customer-assets-agu9un31.emergentagent.net/wingman/ca227688-bb02-408f-9c94-b41af935f248/attachments/2dedbf437f444234a1de2e867fb2e03b_20260917_081722.jpeg',
    galleryLabel: 'Then & Now',
    profileCaption: 'THEN · Keyón in Patriots #7 — Pop Warner youth football',
    additionalPhotos: [
      { id: 'keyon-patriots-11', url: 'https://customer-assets-agu9un31.emergentagent.net/wingman/ca227688-bb02-408f-9c94-b41af935f248/attachments/7cf09c401d1c49cda9fe3e67d39dcf30_IMG_5468.jpeg', caption: 'THEN · Keyón in Patriots #11', fit: 'contain' },
      { id: 'keyon-cathedral-14', url: 'https://customer-assets-agu9un31.emergentagent.net/wingman/ca227688-bb02-408f-9c94-b41af935f248/attachments/6d431ae028644a82bc681e03ade78fab_IMG_4451.JPG', caption: 'NOW · Cathedral High School #14 — Varsity QB1', fit: 'contain' },
      { id: 'keyon-cathedral-3-varsity', url: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/m6qlsc3f_IMG_3196.webp', caption: 'NOW · Under the lights in Cathedral #3 — Varsity QB1, junior year', fit: 'contain' },
    ],
    quote: 'My coaches Mike, Jeff and John were more than just coaches to me — they became family. My Pop Warner experience gave me a strong foundation and prepared me for this next level.',
    bio: "Playing Pop Warner football Brookline Jamaica Plain Patriots was one of the best experiences I've had. I had a lot of fun playing the game, competing against good competition, and learning from coaches who truly cared about me. My coaches Mike, Jeff and John were more than just coaches to me they became family, people I looked up to and appreciated. The teams were very family centered, and I built a brotherhood with my teammates that has lasted until today. I made great friends and built connections that I still have, and I know I can count on them like family. Playing for Brookline Jamaica Plain Patriots also helped prepare me for high school football. It taught me discipline, teamwork, how to compete, and how to stay committed. Now playing for Cathedral High School starting as QB1 on Junior Varsity freshman and sophomore year and now starting as QB1 on varsity in my junior year, I realize how different high school football is from Pop Warner. The competition is stronger, the expectations are higher, and there is a lot more to learn. Even though it is a big learning experience, I feel like my Pop Warner experience gave me a strong foundation and prepared me for this next level. I'm grateful for my coaches, teammates, and everyone who helped me get to where I am today.",
  },
  { name: 'Nick Scott', slug: 'nick-scott', year: 'NFL · SB LVI', position: 'Safety · Super Bowl LVI Champion', school: 'Brookline High School → Penn State → LA Rams', college: 'Penn State — Safety', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/s4u1u0xp_IMG_7783.webp', imgTransform: 'scale(2.2) translate(0%, -22%)', quote: 'It started right here — Brookline Jamaica Plain Patriots is where I first put on the pads. Rep the town that raised you.', bio: 'Nick Scott began his football journey with the Brookline Jamaica Plain Patriots before starring at Brookline High School and Penn State. He made the 2021 Los Angeles Rams 53-man roster and hoisted the Lombardi Trophy as a Super Bowl LVI Champion (Rams 23 – Bengals 20). Career highlights: 200+ NFL tackles, 3 INTs, and appearances with the Rams, Bengals, and Titans. Brothers Irvin and Leon also attended Runkle and Brookline High School — all stars in the classroom and on the field. A huge congrats to parents Lake and Irvin Sr. This achievement is a big deal, and Brookline should be proud.' },
  { name: 'Paul Hammond', slug: 'paul-hammond', year: 'D-I Track · PGR All-American', position: 'Quarterback (#3)', school: 'BJP Patriots → Arlington Catholic → Georgia Storm Prep → New Haven → Savannah State', college: 'Savannah State University · Junior/Senior · Behavioral Analysis', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/8h4vo4xy_IMG_6422.jpg', imgTransform: 'scale(1.35) translate(0%, 5%)', quote: 'Started with the BJP Patriots — now chasing an NFL dream at Savannah State. Same jersey number, same fire.', bio: 'Paul Hammond began his football journey with the Brookline Jamaica Plain Patriots before starring at Arlington Catholic High School. Career honors include Recruit Nation Player of the Week (Arlington Catholic HS), Boston Globe / Boston Herald All-Star, CCL All-Star, and Agganis All-Star Game MVP 2021. After a freshman year at the University of New Haven (NCAA D-II, NE10 Chargers), Paul transferred to Georgia Storm Prep for a post-graduate season, earning PGR All-American honors. He is now at Savannah State University (Junior/Senior classification) majoring in Behavioral Analysis and exploring careers in NFL analysis, athletic direction, and real estate. Another BJP kid taking the field at the collegiate level — proud of you, Paul.' },
  { name: 'Bryquice Brown', slug: 'bryquice-brown', year: 'D-I Football', position: '2013 SB Champion (#7)', school: 'BJP Patriots → Lithia Springs HS → Georgia State → Boston College', college: 'Boston College Eagles Football', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/v0o196h6_Bryquice%20Bruce.jpeg', additionalPhotos: [{ id: 'bryquice-bjp-youth', url: 'https://static.prod-images.emergentagent.com/jobs/8aedbfb6-527b-4739-8472-07f02b35a73f/images/050a3900558bf07abe03195ef3c8b61fe5e8b1a1040046412193e116e22736eb.jpeg', caption: 'Bryquice Brown with the Brookline JP Patriots', fit: 'contain' }], quote: 'BJP Patriots put me on this path — from Pop Warner Super Bowl 57 to the ACC.', bio: 'Bryquice Brown started his football journey with the Brookline Jamaica Plain Patriots, wearing #7 on the 2013 Pee Wee Super Bowl Championship team at ESPN Wide World of Sports. From Brookline he continued to Lithia Springs High School in Georgia, then to Georgia State University, and now suits up for the Boston College Eagles in the ACC — a full-circle return to Boston. Another BJP kid taking the field at the Division I level.' },
  { name: 'Jamari Venter', slug: 'jamari-venter', year: 'Merrimack College · #20', position: 'RB / DB · BJP Alum', school: 'BJP Patriots → Thayer Academy → Merrimack College', college: 'Merrimack College Warriors · NEC Football', img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/lxj57zb1_IMG_7859%202.webp', quote: '"ICE" Brookline Jamaica Plain Patriots is where I first put on the pads. Same drive, new stage.', bio: 'Jamari Venter began his football journey with the "ICE" Brookline Jamaica Plain Patriots before starring at Thayer Academy and continuing on to Merrimack College (Warriors #20 · NEC Football). Off the field, Jamari now represents Herbalife Nutrition — helping people transform their lives through health and wellness. Another BJP kid taking his talent, discipline, and hustle to the next level.' },
  { name: 'Jaylen Roberts', year: 'Class of 2016', position: 'Quarterback', school: 'Milton Academy', img: 'https://images.unsplash.com/photo-1557053815-9f79f70c7980?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHx5b3V0aCUyMGZvb3RiYWxsfGVufDB8fHxibHVlfDE3ODQzNDEwNTN8MA&ixlib=rb-4.1.0&q=85', quote: 'This program shaped me into the leader I am today.', bio: 'Playmaker who set multiple program passing records.' },
  { name: 'Simone Carter', year: 'Class of 2021', position: 'Cheer Co-Captain', school: 'Boston Latin Academy', img: 'https://images.unsplash.com/photo-1705592341761-fdca5d1b7f2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxjaGVlcmxlYWRpbmclMjB0ZWFtfGVufDB8fHx8MTc4NDM0MTA1M3ww&ixlib=rb-4.1.0&q=85', quote: 'Best five years of my life.', bio: 'Stunt captain and tumbling specialist.' },
  { name: 'Tyrell Adams', year: 'Class of 2015', position: 'Defensive Back', school: 'Boston College High', img: 'https://images.pexels.com/photos/9570737/pexels-photo-9570737.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', quote: 'Coaches at BJP are second to none.', bio: 'All-conference cornerback. Now a firefighter in Boston.' },
  { name: 'Nia Bennett', year: 'Class of 2022', position: 'Varsity Cheer', school: 'Newton North HS', img: 'https://images.unsplash.com/photo-1589748239338-afe695e833d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxjaGVlcmxlYWRpbmclMjB0ZWFtfGVufDB8fHx8MTc4NDM0MTA1M3ww&ixlib=rb-4.1.0&q=85', quote: 'Family for life.', bio: 'Choreographer and squad leader for three years.' }
];


// Alumni Memories — Team Photo Archive (grouped by year in descending order)
export const memoryArchive = [
  {
    id: 'mem-new-2013-regional-championship-trophy',
    tag: '2013 Regional Champions',
    title: 'PATRIOTS REGIONAL CHAMPIONS',
    subtitle: 'Championship day with the trophy',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/cgm02k5o_1129131410b.webp',
    imgPosition: 'center center',
  },
  {
    id: 'mem-new-operations-team',
    tag: 'Patriots Legacy',
    title: 'PATRIOTS OPERATIONS TEAM',
    subtitle: 'Program leaders together on the field',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/e1zdaybm_IMG_0160.webp',
    imgRotate: 90,
  },
  {
    id: 'mem-new-revolution-match',
    tag: 'Patriots Family',
    title: 'NEW ENGLAND REVOLUTION MATCH',
    subtitle: 'Patriots family at the stadium',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/xy72dchc_IMG_0829.webp',
    imgPosition: 'center center',
  },
  {
    id: 'mem-new-recognition-podium',
    tag: 'Community Honors',
    title: 'PATRIOTS RECOGNITION CEREMONY',
    subtitle: 'Community leaders at the Patriots podium',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/y0ugsrku_IMG_1092.webp',
    imgFit: 'contain',
  },
  {
    id: 'mem-new-community-honorees',
    tag: 'Community Honors',
    title: 'PATRIOTS COMMUNITY HONOREES',
    subtitle: 'Celebrating service to the Patriots family',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/8lr4wghr_IMG_1094.webp',
    imgPosition: 'center center',
  },
  {
    id: 'mem-new-cheer-regional-champions',
    tag: 'Cheer Champions',
    title: 'JBP CHEER REGIONAL CHAMPIONS',
    subtitle: 'Regional champions with banners and trophies',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/glm566wr_blob-3f8f3bc.webp',
    imgPosition: 'center center',
  },
  {
    id: 'mem-new-coaches-field',
    tag: 'Coaching Legacy',
    title: 'PATRIOTS COACHES ON THE FIELD',
    subtitle: 'Building the program together',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/fgjoeu9v_ice%2Cjonathon.jpeg',
    imgFit: 'contain',
  },
  {
    id: 'mem-new-stadium-family',
    tag: 'Patriots Family',
    title: 'PATRIOTS TOGETHER',
    subtitle: 'Celebrating the team from the stands',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/9cfe714k_IMG_2206.webp',
    imgPosition: 'center center',
  },
  {
    id: 'mem-new-holiday-gathering',
    tag: 'Patriots Family',
    title: 'HOLIDAY GATHERING',
    subtitle: 'Patriots family celebrating together',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/yq0ws8rg_IMG_9075.jpeg',
    imgFit: 'contain',
  },
  {
    id: 'mem-2016-homecoming',
    year: 2016,
    tag: 'Homecoming',
    title: 'JOHNATHON K. · E. YUEN · HARRY K.',
    subtitle: 'with Coach Ian aka "ICE"',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/dqb7397l_IMG_0010.webp',
    imgPosition: 'center 30%',
  },
  {
    id: 'mem-2015-springfield',
    year: 2015,
    tag: 'Springfield College',
    title: 'KEJUAN #48 · DEONTE #29',
    subtitle: 'with Coach Ian aka "ICE"',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/1os2715y_IMG_3118.webp',
    imgRotate: 90,
  },
  {
    id: 'mem-2013-espn',
    year: 2013,
    tag: 'Pop Warner Super Bowl 57 · Dec 7-14',
    title: 'ESPN WIDE WORLD OF SPORTS · ORLANDO',
    subtitle: 'Brookline JP Patriots · PEE WEE Division',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/jpu9umes_FullSizeRender-preview.webp',
    imgPosition: 'center 40%',
    wide: true,
  },
  {
    id: 'mem-2013-sideline',
    year: 2013,
    tag: 'Sideline Family',
    title: 'COACHES · FAMILIES · #42 & #12',
    subtitle: 'The village that raised a program',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/h1e4ymir_IMG_2554.webp',
    imgPosition: 'center 40%',
  },
  {
    id: 'mem-2013-superbowl',
    year: 2013,
    tag: 'Super Bowl Champions',
    title: 'BJP PATRIOTS · 2013 SUPER BOWL',
    subtitle: 'Championship season captured',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/5et0mh9h_2013%20superbowl.webp',
    imgPosition: 'center 40%',
  },
  {
    id: 'mem-2011-superbowl',
    year: 2011,
    tag: 'Super Bowl Season',
    title: 'BJP PATRIOTS · 2011',
    subtitle: 'Another championship run',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/j98zrbi6_2011%20superbowl.webp',
    imgPosition: 'center 40%',
  },
  {
    id: 'mem-2008-superbowl',
    year: 2008,
    tag: 'Super Bowl Era',
    title: 'BJP PATRIOTS · 2008',
    subtitle: 'Building the dynasty',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/fqoorcy8_2008%20superbowl.webp',
    imgPosition: 'center 40%',
  },
  {
    id: 'mem-arc-1',
    year: 2013,
    tag: 'Archive · Locker Room',
    title: 'PATRIOTS UNITED',
    subtitle: 'Team candid',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/2n98ar25_IMG_7848.webp',
    imgPosition: 'center 30%',
  },
  {
    id: 'mem-arc-2',
    year: 2013,
    tag: 'Archive · Team Card',
    title: '#20 · #44',
    subtitle: 'Pee Wee season · brothers in navy',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/hd697un4_IMG_7849.webp',
    imgPosition: 'center 40%',
  },
  {
    id: 'mem-arc-3',
    year: 2013,
    tag: 'Orlando · Where the Memories Begin',
    title: 'DISNEY / ESPN WIDE WORLD',
    subtitle: 'Pop Warner Super Bowl trip',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/ypfyt60t_IMG_7852.webp',
    imgPosition: 'center 40%',
  },
  {
    id: 'mem-arc-4',
    year: 2019,
    tag: 'Division 1 Champions · Team Photo',
    title: 'CHAMPIONSHIP SEASON',
    subtitle: 'Patriots Division 1 title',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/o9r4omq6_IMG_7854.webp',
    imgPosition: 'center 30%',
  },
  {
    id: 'mem-arc-5',
    year: 2013,
    tag: 'ESPN Warmup',
    title: 'GAME-DAY PRACTICE',
    subtitle: 'Orlando · Pop Warner Super Bowl 57',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/gubokjun_IMG_7842.webp',
    imgPosition: 'center 30%',
  },
  {
    id: 'mem-journey-1',
    year: 2013,
    tag: 'Pictorial Journey · Our Love for the Sport',
    title: 'FIELDHOUSE JUBILATION',
    subtitle: 'Trophy in hand · Pop Warner champs',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/uu7rwhea_IMG_7845.webp',
    imgPosition: 'center 30%',
  },
  {
    id: 'mem-journey-2',
    year: 2013,
    tag: 'Pictorial Journey · Our Love for the Sport',
    title: 'PRE-GAME · #48',
    subtitle: 'Fans, families, and quiet nerves before kickoff',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/7m57xhft_IMG_7846.webp',
    imgPosition: 'center 40%',
  },
  {
    id: 'mem-journey-3',
    year: 2013,
    tag: 'Pictorial Journey · Our Love for the Sport',
    title: 'CHAMPIONSHIP NIGHT · COACH JEFF · #8 · #4',
    subtitle: 'Red hats, big trophy, bigger smiles',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/5bci4ju3_IMG_7847.webp',
    imgPosition: 'center 30%',
  },
  {
    id: 'mem-journey-4',
    year: 2021,
    tag: 'National League · D-II Champions',
    title: 'CHAMPIONSHIP PLAQUE',
    subtitle: '2021 National League · Division II title',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/13c1ca8k_IMG_7844.webp',
    imgPosition: 'center 30%',
  },
  {
    id: 'mem-journey-5',
    year: 2013,
    tag: 'Pictorial Journey · Our Love for the Sport',
    title: '#2 · #13 · PRE-GAME PATRIOTS',
    subtitle: 'Two Patriots, one dream',
    img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_navy-red-hub/artifacts/ogye4tdc_IMG_7843.webp',
    imgPosition: 'center 30%',
  },
];
